import React, { useEffect, useState } from 'react';
import licenseRequestService from '../services/licenseRequestService';

const statusStyles = {
  PENDING: 'bg-amber-50 text-amber-800 border-amber-200',
  APPROVED: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  REJECTED: 'bg-rose-50 text-rose-800 border-rose-200',
};

const MyLicenseRequests = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await licenseRequestService.myRequests();
        setItems(res?.requests || res);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">My License Requests</h1>
      <div className="bg-white rounded-xl shadow border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Submitted</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Type</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Nodes</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Sockets</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {loading ? (
              <tr><td className="px-4 py-6 text-gray-500" colSpan={5}>Loading…</td></tr>
            ) : items.length === 0 ? (
              <tr><td className="px-4 py-6 text-gray-500" colSpan={5}>No requests yet</td></tr>
            ) : items.map((r) => (
              <tr key={r.id}>
                <td className="px-4 py-3 text-sm text-gray-700">{new Date(r.createdAt).toLocaleString()}</td>
                <td className="px-4 py-3 text-sm">{r.type}</td>
                <td className="px-4 py-3 text-sm">{r.nodes}</td>
                <td className="px-4 py-3 text-sm">{r.sockets}</td>
                <td className="px-4 py-3">
                  <span className={`inline-flex items-center px-2 py-1 rounded-lg border text-xs font-medium ${statusStyles[r.status]}`}>{r.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MyLicenseRequests;
